// src/components/SyncStatusBanner.js
import React from 'react';
import useOfflineSync from '../hooks/useOfflineSync';

export default function SyncStatusBanner() {
  const { pending, syncing, total, online, syncNow } = useOfflineSync();

  if (pending === 0 && !syncing && online) return null; // nothing to show

  let text;
  let bg = '#f59e0b'; // amber
  if (syncing) {
    // Show the whole batch size and how many are done, so the count doesn't
    // appear to "drop" as recordings upload one by one.
    const totalCount = total || pending;
    const done = Math.max(0, totalCount - pending);
    text = `🔄 Syncing ${totalCount} recording(s)... (${done}/${totalCount} done)`;
    bg = '#3b82f6'; // blue
  } else if (!online) {
    text = `📴 Offline${pending ? ` — ${pending} recording(s) saved, will sync` : ''}`;
  } else if (pending > 0) {
    text = `⏳ ${pending} recording(s) pending sync`;
  }

  return (
    <div
      onClick={() => online && syncNow()}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
        background: bg, color: '#fff', textAlign: 'center',
        padding: '6px 12px', fontSize: 14, cursor: online ? 'pointer' : 'default',
      }}
      title={online ? 'Tap to sync now' : ''}
    >
      {text}
    </div>
  );
}
